import { Container, Wrapper, Label, Value } from "./styles";
import InfoTooltip from "@/components/InfoTooltip";

export type ParameterProps = {
  _key: string;
  attribute: {
    _id: string;
    name: string;
    unit: string;
  };
  values: string[];
};

const Parameter: React.FC<{ parameter: ParameterProps }> = ({ parameter }) => {
  const { values, attribute } = parameter;
  const isEco = attribute._id === "ecopositive" && values.includes("available");

  return (
    <Container>
      {isEco ? (
        <a id="tooltip-info">
          <Wrapper $isEco={true}>
            <Label $isEco={true}>{attribute.name}:</Label>
            <Value $isEco={true}>
              {`${values.join(", ")} ${attribute.unit || ""}`}
              <InfoTooltip />
            </Value>
          </Wrapper>
        </a>
      ) : (
        <Wrapper $isEco={false}>
          <Label $isEco={false}>{attribute.name}:</Label>
          <Value $isEco={false}>
            {`${values.join(", ")} ${attribute.unit || ""}`}
          </Value>
        </Wrapper>
      )}
    </Container>
  );
};

export default Parameter;
